import { Flex, Text } from 'components/uiKit'
import { colors } from 'shared/constants/values'

import s from './Status.module.scss'

export const enum StatusUIType {
  green = 'green',
  orange = 'orange',
  red = 'red',
  corp = 'corp',
  gray = 'gray',
}

const getColorFromType = {
  [StatusUIType.green]: colors.green,
  [StatusUIType.orange]: colors.orange,
  [StatusUIType.red]: colors.red,
  [StatusUIType.corp]: colors.corpMain,
  [StatusUIType.gray]: colors.secondary,
}

type StatusProps = {
  title: string
  type: StatusUIType
  smallSize?: boolean
}

export const Status = ({ title, type, smallSize }: StatusProps) => {
  return (
    <Flex className={s.Status} style={{ border: `1px solid ${getColorFromType[type]}` }}>
      <Text style={{ color: getColorFromType[type], fontSize: smallSize ? 12 : undefined }}>{title}</Text>
    </Flex>
  )
}
